var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"multiple":_vm.multiple ? true : false,"items":_vm.items,"label":_vm.label,"item-text":"name","item-value":"_id","clearable":"","outlined":"","dense":"","hide-details":_vm.hideDetails ? _vm.hideDetails : false},on:{"input":(event) => {
    _vm.$emit('input', event);
  }},model:{value:(_vm.selectedMember),callback:function ($$v) {_vm.selectedMember=$$v},expression:"selectedMember"}})
}
var staticRenderFns = []

export { render, staticRenderFns }